import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const [username, setUsername] = useState('');

  useEffect(() => {
    async function updateUser() {
      try {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        });
        setUsername(user.attributes.email);
      } catch (error) {
        console.log(error);
      }
    }

    updateUser();

    return function cleanup() {};
  }, []);

  return (
    <footer>
      <Box
        sx={{
          backgroundColor: '#aaaaaa',
          paddingLeft: 3,
        }}
      >
        <Typography variant="caption">{username}</Typography>
      </Box>
    </footer>
  );
};
export default Footer;
